exports.load = function() {

  var module = angular.module('bbl.support', []);

  require('./support-style.less');
  require('./support-controller').inject(module);
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/support/index.js
 ** module id = 311
 ** module chunks = 0
 **/